import { render } from "./Pagination.vue?vue&type=template&id=011f7abc&bindings={\"disabled\":\"props\",\"page\":\"props\",\"pages\":\"props\",\"query\":\"options\"}"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script